/**
 * FAQ Toggle — Adds/removes `active` class on .faq-item
 * when its .faq-toggle is clicked.
 */
(function () {
  'use strict';
 
  function init() {
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('.faq-toggle');
      if (!toggle) return;
 
      var item = toggle.closest('.faq-item');
      if (item) item.classList.toggle('active');
    });
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();